import { createSelector } from 'reselect'
import * as R from 'ramda'

const allSpecsSelector = state => state.product.productSpecsSelection.productSpecs ? state.product.productSpecsSelection.productSpecs : {}
const specSourcesSelector = state => state.product.productSpecsSelection.productSpecs.data ? state.product.productSpecsSelection.productSpecs.data.specSources : {}
const allRevisionsSelector = state => state.product.productSpecsSelection.productSpecs.data ? state.product.productSpecsSelection.productSpecs.data.specRevisions : {}
const revisionDialogActiveSelector = state => state.product.productSpecsSelection.revisionDialogActive || false
const importDialogActiveSelector = state => state.product.productSpecsSelection.importDialogActive || false
const importSkusListSelector = state => state.product.productSpecsSelection.importSkusList || []
const currRevisionNumberSelectorHoc = state => state.product.productSpecsSelection.selectedRevision
const editModeSelector = state => state.product.productSpecsSelection.edit || false
const isLoadingSelector = state => state.product.productSpecsSelection.isLoading || false
const hideSpecificationsTableSelector = state => state.product.productSpecsSelection.hideSpecificationsTable || false

const latestRevisionNumberSelector = createSelector(
  allRevisionsSelector,
  (revisions) => revisions && Object.keys(revisions).length
)

const currRevisionNumberSelector = createSelector(
  currRevisionNumberSelectorHoc,
  latestRevisionNumberSelector,
  (currRevision, latestRevision) => {
    return currRevision ? currRevision : latestRevision
  }
)

const lastUpdatedDateSelector = createSelector(
  currRevisionNumberSelector,
  allRevisionsSelector,
  (revisionNumber, revisions) => {
    const currRevision = R.prop(revisionNumber, revisions)
    return currRevision ? R.prop('dateCreated', currRevision) : ''
  }
)

const lastUpdatedUserSelector = createSelector(
  currRevisionNumberSelector,
  allRevisionsSelector,
  (revisionNumber, revisions) => {
    const currRevision = R.prop(revisionNumber, revisions)
    return currRevision ? R.prop('user', currRevision) : ''
  }
)

const specsSelector = createSelector(
  currRevisionNumberSelector,
  allRevisionsSelector,
  (revisionNumber, revisions) => {
    const currRevision = R.prop(revisionNumber, revisions)
    return currRevision ? R.prop('data', currRevision) : []
  }
)

const sectionHeaderSelector = createSelector(
  specSourcesSelector,
  (specSources) => {
    return R.keys(specSources)
  }
)

export {
  specsSelector,
  hideSpecificationsTableSelector,
  allSpecsSelector,
  sectionHeaderSelector,
  specSourcesSelector,
  allRevisionsSelector,
  currRevisionNumberSelector,
  latestRevisionNumberSelector,
  revisionDialogActiveSelector,
  importDialogActiveSelector,
  editModeSelector,
  isLoadingSelector,
  importSkusListSelector,
  lastUpdatedDateSelector,
  lastUpdatedUserSelector,
}
